<div class="bg-[#FAFAFA] rounded-[20px] p-4 sm:p-6 space-y-6">

  <!-- PAGE HEADER -->
  <div class="flex items-center justify-between w-full">
    <h1 class="text-xl sm:text-xl font-semibold text-[#444A6D]">
      {{ 'CLIENT.TITLE' | translate }}
    </h1>
    <button class="bg-secondary text-white text-sm px-4 py-2 rounded-lg" (click)="openAddClientPopup()">
      + {{ 'CLIENT.ADD_CLIENT' | translate }}
    </button>
  </div>

  <!-- SUMMARY CARD -->
  <div
    class="bg-white rounded-xl shadow-sm p-4 sm:p-5 mb-2 flex flex-col lg:flex-row lg:items-center justify-between gap-4 lg:gap-6 text-md"
  >

    <!-- existing summary values (unchanged), arranged as two rows of two -->
    <div class="grid grid-cols-2 gap-x-10 gap-y-2">
      <div>
        {{ 'CLIENT.CONVENTIONAL' | translate }} :
        <span class="font-semibold ms-1">{{ totalConventional | currency:'PKR ':'symbol':'1.0-0' }}</span>
      </div>
      <div>
        {{ 'CLIENT.ISLAMIC' | translate }} :
        <span class="font-semibold ms-1">{{ totalIslamic | currency:'PKR ':'symbol':'1.0-0' }}</span>
      </div>
      <div>
        {{ 'CLIENT.NPL' | translate }} :
        <span class="font-semibold ms-1">{{ totalNpl | currency:'PKR ':'symbol':'1.0-0' }}</span>
      </div>
      <div>
        {{ 'CLIENT.GRAND_TOTAL' | translate }} :
        <span class="font-semibold ms-1">{{ GrandTotal | currency:'PKR ':'symbol':'1.0-0' }}</span>
      </div>
    </div>

    <!-- vertical divider, visible only when the chart sits beside the values -->
    <div class="hidden lg:block w-px self-stretch bg-slate-100"></div>

    <!-- compact pie chart + legend, vertically centered alongside the existing values -->
    <div class="flex items-center gap-3 justify-center lg:justify-start shrink-0">
      <apx-chart
        [series]="summaryChartOptions.series"
        [chart]="summaryChartOptions.chart"
        [labels]="summaryChartOptions.labels"
        [colors]="summaryChartOptions.colors"
        [legend]="summaryChartOptions.legend"
        [dataLabels]="summaryChartOptions.dataLabels"
        [stroke]="summaryChartOptions.stroke"
        [states]="summaryChartOptions.states"
        [plotOptions]="summaryChartOptions.plotOptions"
        [tooltip]="summaryChartOptions.tooltip"
      ></apx-chart>

      <div class="flex flex-col gap-1.5 text-xs font-medium text-[#444A6D]">
        <div class="flex items-center gap-1.5">
          <span
            class="w-2 h-2 rounded-full inline-block ring-2 ring-white shadow-sm"
            [style.background-color]="summaryChartColors[0]"
          ></span>
          {{ 'CLIENT.CONVENTIONAL' | translate }}
        </div>
        <div class="flex items-center gap-1.5">
          <span
            class="w-2 h-2 rounded-full inline-block ring-2 ring-white shadow-sm"
            [style.background-color]="summaryChartColors[1]"
          ></span>
          {{ 'CLIENT.ISLAMIC' | translate }}
        </div>
        <div class="flex items-center gap-1.5">
          <span
            class="w-2 h-2 rounded-full inline-block ring-2 ring-white shadow-sm"
            [style.background-color]="summaryChartColors[2]"
          ></span>
          {{ 'CLIENT.NPL' | translate }}
        </div>
      </div>
    </div>
  </div>

  <!-- CLIENT TABLE -->
  <div>
    <app-table [columns]="columns" [data]="data" [actions]="actions" [enablePagination]="true" [pageSize]="10">
    </app-table>
  </div>
</div>

<!-- ✅ Single popup handles both form and confirm modes -->
<app-popup [title]="popupTitle" [type]="popupType" [fields]="popupFields" [message]="popupMessage"
  [confirmText]="'COMMON.DELETE'" [cancelText]="'COMMON.CANCEL'" [onSave]="handleSave.bind(this)" [show]="showPopup"
  (showChange)="showPopup = $event" (confirmed)="handleDelete()">
</app-popup>